import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, setToken, formatErr } from "../lib/api";
import { Lock, Mail } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setToken(data.token);
      toast.success("Bine ai venit, " + (data.user?.name || "Admin"));
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(formatErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-[#080706] px-6"
      data-testid="admin-login-page"
    >
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(200,169,126,0.08),transparent_60%)]" />
      <form
        onSubmit={submit}
        className="relative w-full max-w-md bg-[#0F0D0B] border border-[#2A2522] p-10"
        data-testid="admin-login-form"
      >
        <p className="text-[10px] font-semibold tracking-[0.32em] uppercase text-[#C8A97E] mb-3">
          — Panou Administrare
        </p>
        <h1 className="font-[Playfair_Display] text-[#FDF8F5] text-3xl leading-tight">
          Bun venit <em className="italic text-[#C8A97E]">înapoi.</em>
        </h1>
        <p className="text-[#9D8B7B] text-sm mt-3 font-light">
          Autentifică-te pentru a gestiona produsele.
        </p>

        <div className="mt-10 space-y-7">
          <div>
            <span className="text-[10px] uppercase tracking-[0.25em] text-[#C8A97E]">Email</span>
            <div className="flex items-center gap-3 border-b border-[#3D3530] focus-within:border-[#C8A97E] transition-colors">
              <Mail size={16} strokeWidth={1.2} className="text-[#9D8B7B]" />
              <input
                data-testid="admin-input-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="flex-1 bg-transparent text-[#FDF8F5] py-3 focus:outline-none"
                placeholder="admin@..."
              />
            </div>
          </div>
          <div>
            <span className="text-[10px] uppercase tracking-[0.25em] text-[#C8A97E]">Parolă</span>
            <div className="flex items-center gap-3 border-b border-[#3D3530] focus-within:border-[#C8A97E] transition-colors">
              <Lock size={16} strokeWidth={1.2} className="text-[#9D8B7B]" />
              <input
                data-testid="admin-input-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="flex-1 bg-transparent text-[#FDF8F5] py-3 focus:outline-none"
                placeholder="••••••••"
              />
            </div>
          </div>
        </div>

        <button
          type="submit"
          data-testid="admin-login-submit"
          disabled={loading}
          className="mt-10 w-full bg-[#C8A97E] text-[#080706] py-4 text-sm font-medium tracking-wide hover:bg-[#B3956D] transition-colors disabled:opacity-60"
        >
          {loading ? "Se autentifică..." : "Autentifică-te"}
        </button>

        <a
          href="/"
          className="block mt-6 text-center text-xs uppercase tracking-[0.2em] text-[#6B5E55] hover:text-[#C8A97E] transition-colors"
        >
          ← Înapoi la site
        </a>
      </form>
    </div>
  );
}
